import React from 'react';
import { Download, ExternalLink } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { useLanguage } from '../../i18n/Locale';
import { evidenceHandoffCopy } from './evidenceHandoffCopy';
import { makeReviewPacket, downloadEvidenceDraft } from './evidenceHandoffExport';

export const EvidenceHandoff = ({value, context, busy}) => {
  const {language} = useLanguage(), t = evidenceHandoffCopy[language] || evidenceHandoffCopy.en;
  const download = kind => {
    try {
      const review = kind === 'review';
      const content = review ? JSON.stringify(makeReviewPacket(value, context, language), null, 2) : t.providerText;
      downloadEvidenceDraft(`stg-${review ? 'feed-review' : 'provider-request'}-${language === 'es' ? 'es' : 'en'}.${review ? 'json' : 'md'}`,
        content, review ? 'application/json;charset=utf-8' : 'text/markdown;charset=utf-8');
      toast.success(<span data-testid="evidence-handoff-success">{t.downloaded}</span>, {id: 'evidence-handoff'});
    } catch {
      toast.error(<span data-testid="evidence-handoff-error">{t.error}</span>, {id: 'evidence-handoff'});
    }
  };
  return <section className="evidence-band" data-testid="evidence-handoff-section">
    <h2 data-testid="evidence-handoff-title">{t.title}</h2>
    <div className="evidence-handoff-grid">
      <div>
        <h3 data-testid="provider-request-title">{t.provider}</h3>
        <p className="evidence-draft-state" data-testid="provider-request-state">{t.unsent}</p>
        <p data-testid="provider-request-scope">{t.providerScope}</p>
        <Button variant="outline" data-testid="provider-request-download" disabled={busy} onClick={() => download('provider')}><Download size={16}/>{t.request}</Button>
        <a data-testid="provider-request-dashboard" className="evidence-contact-link" href="https://dashboard.biconomy.io/" target="_blank" rel="noopener noreferrer"><ExternalLink size={14}/>{t.dashboard}</a>
      </div>
      <div>
        <h3 data-testid="feed-review-packet-title">{t.reviewer}</h3>
        <p className="evidence-draft-state" data-testid="feed-review-packet-state">{t.unassigned}</p>
        <p data-testid="feed-review-packet-scope">{t.reviewerScope}</p>
        <Button variant="outline" data-testid="feed-review-packet-download" disabled={busy} onClick={() => download('review')}><Download size={16}/>{t.packet}</Button>
      </div>
    </div>
    <p data-testid="evidence-handoff-boundary">{t.boundary}</p>
  </section>;
};